// src/components/common/Pagination/Pagination.jsx
import React from "react";
import "./Pagination.css";

export default function Pagination({
    currentPage,
    totalPages,
    pageSize,
    totalItems,
    onPageChange
  
}) {
    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(start + pageSize - 1, totalItems);
  const handleClick = function (page) {
    if (onPageChange) {
      onPageChange(page);
    }
  };

  return (
    <div className="pagination-container">

      {/* Left side summary */}
      <span className="pagination-summary">
        Showing <span className="pagination-bold">{start}-{end}</span> of{" "}
        <span className="pagination-bold">{totalItems}</span>
      </span>

      {/* Right side list */}
      <ul className="pagination-list">
        {/* Previous */}
        <li>
          <button
            className="pagination-btn pagination-prev"
            disabled={currentPage === 1}
            onClick={function () {
              if (currentPage > 1) handleClick(currentPage - 1);
            }}
          >
            Previous
          </button>
        </li>

        {/* Page Numbers */}
        {Array.from({ length: totalPages }).map(function (_, index) {
          const pageNum = index + 1;
          const isActive = pageNum === currentPage;

          return (
            <li key={pageNum}>
              <button
                className={
                  "pagination-btn " +
                  (isActive ? "pagination-active" : "")
                }
                onClick={function () {
                  handleClick(pageNum);
                }}
              >
                {pageNum}
              </button>
            </li>
          );
        })}

        {/* Next */}
        <li>
          <button
            className="pagination-btn pagination-next"
            disabled={currentPage === totalPages}
            onClick={function () {
              if (currentPage < totalPages) handleClick(currentPage + 1);
            }}
          >
            Next
          </button>
        </li>
      </ul>
    </div>
  );
}
